import {
    LoanApplication,
    LoanApplicationResponse,
    LoanApplicationResult,
    PricingResponse,
} from '@/api/LeaBank/leaBank.interfaces';
import {
    DwellingType,
    EmploymentType,
    ExpenseType,
    IncomeType,
    MaritalStatus,
    Period,
} from '@/api/LeaBank/leaBank.interfaces.applicant';

export const fakeApprovedResponse = {
    result: LoanApplicationResult.Approved,
    payload:
        'https://lea-bank-dev-consumer-loan-signing-process.azurewebsites.net/94e9ec2d-03e0-45e5-9fa4-f60291ea445f',
};

export const fakeDeclinedResponse: LoanApplicationResponse = {
    result: LoanApplicationResult.Declined,
    payload: null,
};

export const fakeCancelledResponse: LoanApplicationResponse = {
    result: LoanApplicationResult.Canceled,
};

export const fakePricingResponse: PricingResponse = [
    {
        installments: 0,
        amount: 11390,
        initialFee: 49,
        interestRate: 0,
    },
    {
        installments: 3,
        amount: 3846,
        initialFee: 195,
        interestRate: 0,
    },
    {
        installments: 6,
        amount: 1948,
        initialFee: 195,
        interestRate: 0,
    },
    {
        installments: 12,
        amount: 999,
        initialFee: 295,
        interestRate: 0,
    },
    {
        installments: null,
        amount: null,
        initialFee: 49,
        interestRate: 19.9,
    },
];

export const fakeBasicLoanApplication: LoanApplication = {
    application: {
        appliedAmount: 15000,
        appliedRepaymentTime: 3,
    },
    applicant: {
        nationalId: '197305091246',
        numberOfChildrenBelow18: 0,
        dwelling: {
            type: DwellingType.OwnApartment,
        },
        employment: {
            type: EmploymentType.PermanentEmployment,
        },
        maritalStatus: MaritalStatus.Married,
        income: [
            {
                amount: 54000,
                type: IncomeType.GrossIncome,
                period: Period.monthly,
            },
        ],
        expenses: [
            {
                amount: 99,
                type: ExpenseType.RentalCost,
                period: Period.monthly,
            },
        ],
    },
    purchase: [],
};
